import React from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import Notfound from './pages/NotFound.jsx';

import CreateCampaign from './pages/campaigns/create/CreateCampaign.jsx';
import Campaigns from './pages/campaigns/Campaigns.jsx';
import Home from './pages/home/Home.jsx';
import Login from './pages/auth/login/Login.jsx';
import Signup from './pages/auth/signup/Signup.jsx';
import ForgotPassword from './pages/auth/forgot-password/ForgotPassword.jsx';
import Dashboard from './pages/dashboard/Dashboard.jsx';
import CustomersPage from './pages/customers/CustomersPage.jsx';
import TransactionsPage from './pages/transactions/TransactionsPage.jsx';
import WalletPage from './pages/wallet/WalletPage.jsx';
import VouchersPage from './pages/vouchers/VouchersPage.jsx';
import SchemaPage from './pages/schema/SchemaPage.jsx';
import SettingsPage from './pages/settings/SettingsPage.jsx';
import CustomerProfilePage from './pages/customers/profile/CustomerProfilePage.jsx';
import AdminPublicRoute from './components/routes/AdminPublicRoute.js';
import AdminProtectedRoute from './components/routes/AdminProtectedRoute.js';
import UserProtectedRoute from './components/routes/UserProtectedRoute.js';
import Otp from './pages/auth/signup/Otp.js';
import EditCampaign from './pages/campaigns/create/EditCampaign.jsx';
import CreateVoucherPage from './pages/vouchers/CreateVoucherPage.jsx';
import EditVoucherPage from './pages/vouchers/EditVoucherPage.jsx';
import PostTransaction from './pages/transactions/PostTransaction.jsx';
import MerchantList from './superAdmin/MerchantList.jsx';
import NotFound from './components/routes/NotFound.js';
import Contact from './superAdmin/ContactUs.jsx';



export default function App() {
  return (
    <div>

      <Routes>
        <Route path="/" element={<UserProtectedRoute> <Dashboard /></UserProtectedRoute>} />
        <Route path="/login" element={<Login />} />
        <Route path="/otp-verification" element={<AdminPublicRoute> <Otp /></AdminPublicRoute>} />

        <Route path="/signup" element={<AdminPublicRoute> <Signup /></AdminPublicRoute>} />
        <Route path="/forgot-password" element={<AdminPublicRoute> <ForgotPassword /></AdminPublicRoute>} />
       
        <Route path='/dashboard' element={<UserProtectedRoute> <Dashboard /></UserProtectedRoute>} />
          <Route path='/contact-us' element={<UserProtectedRoute> <Contact /></UserProtectedRoute>} />
        <Route path='/campaigns/create' element={<UserProtectedRoute> <CreateCampaign /></UserProtectedRoute>} />
        <Route path='/campaigns/edit/:id' element={<UserProtectedRoute> <EditCampaign /></UserProtectedRoute>} />
        <Route path='/campaigns' element={<UserProtectedRoute> <Campaigns /></UserProtectedRoute>} />
        <Route path='/customers' element={<UserProtectedRoute> <CustomersPage /></UserProtectedRoute>} />
        <Route path='/customers/:id' element={<UserProtectedRoute> <CustomerProfilePage /></UserProtectedRoute>} />
        <Route path='/transactions' element={<UserProtectedRoute> <TransactionsPage /></UserProtectedRoute>} />
        <Route path='/wallet' element={<UserProtectedRoute> <WalletPage /></UserProtectedRoute>} />
        <Route path='/create-voucher' element={<UserProtectedRoute> <CreateVoucherPage /></UserProtectedRoute>} />
        <Route path='/edit-voucher/:code' element={<UserProtectedRoute> <EditVoucherPage /></UserProtectedRoute>} />
        <Route path='/vouchers' element={<UserProtectedRoute> <VouchersPage /></UserProtectedRoute>} />
        <Route path='/schema' element={<UserProtectedRoute> <SchemaPage /></UserProtectedRoute>} />
        <Route path='/settings' element={<UserProtectedRoute> <SettingsPage /></UserProtectedRoute>} />
        <Route path='/post-transaction' element={<UserProtectedRoute> <PostTransaction /></UserProtectedRoute>} />
       
      <Route path='/merchant-list' element={<UserProtectedRoute> <MerchantList /> </UserProtectedRoute>} />


        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}
